module.exports = __webpack_public_path__ + "img/nav-right-search-below-chevy.520ea848.png";